import React,{useState,useEffect,useRef} from 'react';
import { Toaster } from 'react-hot-toast';
import {Row,Col,Form,Table,Button,Modal,Spinner} from 'react-bootstrap';
import './Directorio.css';

import { useSelector, useDispatch } from 'react-redux';
import { setStateGlobal, showAlert } from '../../reducers/appReducer';

import moment from "moment";
import "moment/locale/es";
moment.locale("mx");

function _GET(variable) {
  let query = window.location.search.substring(1);
  let vars = query.split('&');
  for (let i = 0; i < vars.length; i++) {
    let pair = vars[i].split('=');
    if (decodeURIComponent(pair[0]) == variable) {
      return decodeURIComponent(pair[1]);
    }
  }
  return '';
}

export const Directorio  = ({socket}) => {

  const globalState = useSelector( (state) => state.agents );
  const dispatch = useDispatch();

  const refInputEditar = useRef(null);
  let arrNuevoCliente = { ...globalState.arrNuevoCliente }
  let itemDireccion = {calle: '',colonia: '',ciudad: '',municipio: '',estado: '',telefono: '',tipo: '', }
  let itemCorreo = { tipo_correo: 'EMPRESARIAL', correo: '', descripcion: '', };
  let itemAcceso = { dependencia: '', usuario: '', password: '', observaciones: ''};

  let arrTipoPersona = [
    { id: 'fisica', name: 'FÍSICA', },
    { id: 'fisica_empresarial', name: 'FÍSICA CON ACTIVIDAD EMPRESARIAL', },
    { id: 'moral', name: 'MORAL', },
  ]

  const [arrClientes,   setClientes] = useState([]);
  const [arrEjecutivos, setEjecutivos] = useState([]);
  const [arrVendedores, setVendedores] = useState([]);
  const [arrGrupos, setGrupos] = useState([]);
  const [modalGrupo, setModalGrupo] = useState(false);
  const [btnSaveIsLoading,setBtnSaveIsLoading] = useState(false);
  const [modalEditarGrupo,setModalEditarGrupo] = useState(false);
  const [indexEditarGrupo,setIndexEditarGrupo] = useState('');
  const [btnLoadingEditar, setBtnLoadingEditar] = useState(false);

  const handleShowModalGrupo = () => setModalGrupo(true);
  const handleCloseModalGrupo = () => setModalGrupo(false);

  const handleShowModalEditarGrupo = () => setModalEditarGrupo(true);
  const handleCloseModalEditarGrupo = () => setModalEditarGrupo(false);

  const handleSubmitFormGrupo = (e) => {
    e.preventDefault();
    const nombre_grupo = e.target.nombre_grupo.value;
    const data = {
      nombre: nombre_grupo
    }
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveGrupo',{
      method: 'POST',
      mode: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json() )
    .then( response => {
      getDirectorioNuevo();
      handleCloseModalGrupo();
    })
  }

  const getDirectorioNuevo = () => {
    const data = {  }
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=getDirectorioNuevo',{
      method: 'POST',
      model: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json())
    .then( res => {
      setClientes( res.clientes.documents )
      setEjecutivos( res.ejecutivos.documents )
      setVendedores( res.vendedores.documents )
      setGrupos( res.grupos.documents )
    })
  }

  const saveEditarGrupo = (item) => {
    setBtnLoadingEditar(true);
    const data = {
      id_grupo : item._id,
      nombre : refInputEditar.current.value
    }
    fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=updateNombreGrupo',{
      method: 'POST',
      model: 'cors',
      body: JSON.stringify(data)
    })
    .then( response => response.json())
    .then( response => {
      setBtnLoadingEditar(false);
      getDirectorioNuevo();
      console.log(response);
    })
  }

  useEffect(() => {
    getDirectorioNuevo();
  },[]);

  useEffect( () => {
    if(_GET('id')!==''){
      console.log('arrCliente', arrClientes)
      arrNuevoCliente = { ...arrClientes.filter( element => element['_id'] == _GET('id') )[0] , update: true }
      console.log('dataCliente', arrNuevoCliente);
      if(arrNuevoCliente && arrNuevoCliente['_id']){
        dispatch( setStateGlobal({ arrNuevoCliente }) )
      }
    }
  },[arrClientes])

  return(
    <div className="container-fluid"> 
      <div className="ws-main-container-directorio"> 

        {/* TOAST NOTIFICATION */}
        <Toaster position='top-right' />

        <Row className="mb-3"> 
          <Col xs={12}>
            <Button className="ws-btn-blue-2"
            onClick={ () => {
              window.location.href = "/"
            }}
            ><i className="bi bi-arrow-left"></i>&nbsp;Atrás</Button> 
          </Col>
        </Row>
        <div className="ws-main-content-top">
          <Row className='align-items-center'> 
            <Col xs={4}>
              <Form >  
                <span className='ws-main-content-top-item ws-main-content-text'>Buscar Contratante</span>
                <Form.Select onChange={(ev) => {
                  arrNuevoCliente = { ...arrClientes.filter( element => element['_id'] == ev.target.value)[0] , update: true }
                  if(typeof arrNuevoCliente.arrAccesos === 'undefined' ){
                    arrNuevoCliente.newAcceso = false
                    arrNuevoCliente.arrAccesos = []
                  }
                  dispatch( setStateGlobal({ arrNuevoCliente, }) )
                }} className='ws-main-content-top-item ws-input-select'>
                  <option value="">Selecciona un cliente...</option>
                  {
                    arrClientes.map((t,e) => (
                      <option value={t['_id']} key={`key-${e}`}>{t.nombre_completo}</option>
                    ))
                  }
                </Form.Select>
              </Form>
            </Col>
            <Col xs={8}>
              <Form>
                <span className='ws-main-content-top-item ws-main-content-text'>Mostrar como |</span>
                <Form.Check checked={(arrNuevoCliente.isContratante) ? true : false} onClick={(ev) => {
                  arrNuevoCliente.isContratante = !arrNuevoCliente.isContratante
                  dispatch( setStateGlobal({ arrNuevoCliente, }) )
                }} className="ws-check-option" inline label="Contratante" name="" type="checkbox" />
                <Form.Check checked={(arrNuevoCliente.isCompania) ? true : false} onClick={(ev) => {
                  arrNuevoCliente.isCompania = !arrNuevoCliente.isCompania
                  dispatch( setStateGlobal({ arrNuevoCliente, }) )
                }} className="ws-check-option" inline label="Compañia" name="" type="checkbox" />
                <Form.Check checked={(arrNuevoCliente.isAgente) ? true : false} onClick={(ev) => {
                  arrNuevoCliente.isAgente = !arrNuevoCliente.isAgente
                  dispatch( setStateGlobal({ arrNuevoCliente, }) )
                }} className="ws-check-option" inline label="Agente" name="" type="checkbox" />
                <Form.Check checked={(arrNuevoCliente.isVendedor) ? true : false} onClick={(ev) => {
                  arrNuevoCliente.isVendedor = !arrNuevoCliente.isVendedor
                  dispatch( setStateGlobal({ arrNuevoCliente, }) )
                }} className="ws-check-option" inline label="Vendedor" name="" type="checkbox" />
                <Form.Check checked={(arrNuevoCliente.isEjecutivo) ? true : false} onClick={(ev) => {
                  arrNuevoCliente.isEjecutivo = !arrNuevoCliente.isEjecutivo
                  dispatch( setStateGlobal({ arrNuevoCliente, }) )
                }} className="ws-check-option" inline label="Ejecutivo" name="" type="checkbox" />
                <Form.Check checked={(arrNuevoCliente.isProspecto) ? true : false} onClick={(ev) => {
                  arrNuevoCliente.isProspecto = !arrNuevoCliente.isProspecto
                  dispatch( setStateGlobal({ arrNuevoCliente, }) )
                }} className="ws-check-option" inline label="Prospecto" name="" type="checkbox" />
              </Form> 
            </Col>
          </Row>
        </div>
        <div className="ws-main-content-body">

          <Form>
            <Row>

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalTipoPersona">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Tipo de persona
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Select onChange={(ev) => {
                      arrNuevoCliente.tipo_persona = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}>
                      { arrTipoPersona.map((t,e) => (
                          <option key={`e-${e}`} value={t.id}>{t.name}</option>
                      )) }
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>

              {
                arrNuevoCliente.tipo_persona === 'moral' && (
                  <Col xs={12} md={4}>
                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalRazonSocial">
                      <Form.Label column sm={5} className="text-end ws-form-text-input">
                        Razón social
                      </Form.Label>
                      <Col sm={7}>
                        <Form.Control type="text" name="razon_social" value={arrNuevoCliente.razon_social} onChange={(ev) => {
                          arrNuevoCliente.razon_social = ev.target.value
                          dispatch( setStateGlobal({ arrNuevoCliente, }) )
                        }} />
                      </Col>
                    </Form.Group>
                  </Col>
                )
              }
              
              {
                arrNuevoCliente.tipo_persona !== 'moral' && (
                  <React.Fragment>  

                    <Col xs={12} md={4}>
                      <Form.Group as={Row} className="mb-3" controlId="formHorizontalGenero">
                        <Form.Label column sm={5} className="text-end ws-form-text-input">
                          Género
                        </Form.Label>
                        <Col sm={7}>
                          <Form.Select onChange={(ev) => {
                            arrNuevoCliente.genero = ev.target.value
                            dispatch( setStateGlobal({ arrNuevoCliente, }) )
                          }}>
                            <option value="" disabled={'disabled'}>Selecciona un género</option>
                            <option value="Masculino">Masculino</option>
                            <option value="Femenino">Femenino</option>
                          </Form.Select>
                        </Col>
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={4}>
                      <Form.Group as={Row} className="mb-3" controlId="formHorizontalNombre">
                        <Form.Label column sm={5} className="text-end ws-form-text-input">
                          Nombre
                        </Form.Label>
                        <Col sm={7}>
                          <Form.Control name="nombre" value={arrNuevoCliente.nombre}  onChange={(ev) => {
                            arrNuevoCliente.nombre = ev.target.value
                            dispatch( setStateGlobal({ arrNuevoCliente, }) )
                          }}/>
                        </Col>
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={4}>
                      <Form.Group as={Row} className="mb-3" controlId="formHorizontalPaterno">
                        <Form.Label column sm={5} className="text-end ws-form-text-input">
                          Paterno
                        </Form.Label>
                        <Col sm={7}>
                          <Form.Control name="paterno" value={arrNuevoCliente.paterno} onChange={(ev) => {
                            arrNuevoCliente.paterno = ev.target.value
                            dispatch( setStateGlobal({ arrNuevoCliente, }) )
                          }} />
                        </Col>
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={4}>
                      <Form.Group as={Row} className="mb-3" controlId="formHorizontalMaterno">
                        <Form.Label column sm={5} className="text-end ws-form-text-input">
                          Materno
                        </Form.Label>
                        <Col sm={7}>
                          <Form.Control name="materno" value={arrNuevoCliente.materno} onChange={(ev) => {
                            arrNuevoCliente.materno = ev.target.value
                            dispatch( setStateGlobal({ arrNuevoCliente, }) )
                          }}/>
                        </Col>
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={4}>
                      <Form.Group as={Row} className="mb-3" controlId="formHorizontalFechaNacimiento">
                        <Form.Label column sm={5} className="text-end ws-form-text-input">
                          Fecha de nacimiento
                        </Form.Label>
                        <Col sm={7}>
                          <Form.Control type="date" name="fecha_nacimiento" value={arrNuevoCliente.birthday} onChange={(ev) => {
                            arrNuevoCliente.birthday = ev.target.value
                            dispatch( setStateGlobal({ arrNuevoCliente, }) )
                          }} />
                        </Col>
                      </Form.Group>
                    </Col>

                  </React.Fragment>
                )
              }
              
              {
                arrNuevoCliente.tipo_persona !== 'moral' && (
                  <Col xs={12} md={4}>
                    <Form.Group as={Row} className="mb-3" controlId="formHorizontalNombre">
                      <Form.Label column sm={5} className="text-end ws-form-text-input">
                        Nombre Completo
                      </Form.Label>
                      <Col sm={7}>
                        <Form.Control disabled={'disabled'} name="nombre_completo" value={ `${arrNuevoCliente.nombre} ${arrNuevoCliente.paterno} ${arrNuevoCliente.materno}` } />
                      </Col>
                    </Form.Group>
                  </Col>
                )
              }
              
              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalRFC">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    RFC
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control name="rfc" value={arrNuevoCliente.rfc} onChange={(ev) => {
                      arrNuevoCliente.rfc = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}/>
                  </Col>
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalCurp">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    CURP
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control name="curp" value={arrNuevoCliente.curp} onChange={(ev) => {
                      arrNuevoCliente.curp = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}/>
                  </Col>
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalNacionalidad">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Nacionalidad
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Select value={arrNuevoCliente.nacionalidad} onChange={(ev) => {
                      arrNuevoCliente.nacionalidad = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}>
                      <option value="MEXICANO">MEXICANO</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalCategoria">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Categoría
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Select value={arrNuevoCliente.categoria} onChange={(ev) => {
                      arrNuevoCliente.categoria = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}>
                      <option value="">Selecciona una categoría</option>
                      <option value="1">Cliente 360 - 50%</option>
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>
              
              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalExpediente">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Expediente
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control name="expediente" value={arrNuevoCliente.expediente} onChange={(ev) => {
                      arrNuevoCliente.expediente = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}/>
                  </Col>
                </Form.Group>
              </Col>
              
              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalFechaRegistro">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Fecha de registro
                  </Form.Label>
                  <Col sm={7}>
                    {/* FALTA */}
                    <Form.Control type="date" name="fecha_registro" value={arrNuevoCliente.fecha_registro} />
                  </Col>
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalEjecutivo">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Ejecutivo
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Select value={arrNuevoCliente.ejecutivo} onChange={(ev) => {
                      arrNuevoCliente.ejecutivo = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}>
                      <option value="">Selecciona un ejecutivo</option>
                      {
                        arrEjecutivos.map((t,e) => (
                          <option value={e} key={`key-${e}`}>{t.nombre_completo}</option>
                        ))
                      }
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalAreaEmpresa">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Area/Empresa
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control name="area_empresa" value={arrNuevoCliente.empresa}  onChange={(ev) => {
                      arrNuevoCliente.empresa = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}/>
                  </Col>
                </Form.Group>
              </Col>
              
              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalVendedor">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Vendedor
                  </Form.Label>
                  <Col sm={7}>
                    {/* FALTA */}
                    <Form.Select value={arrNuevoCliente.vendedor}
                    onChange={(ev) => {
                      arrNuevoCliente.vendedor = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}
                    >
                      <option value="">Selecciona un vendedor</option>
                      {
                        arrVendedores.map((t,e) => (
                          <option value={t["_id"]} key={`key-${e}`}>{t.nombre_completo}</option>
                        ))
                      }
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalComision">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    % de comisión
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control 
                    name="comision" 
                    value={arrNuevoCliente.comision}  
                    onChange={(ev) => {
                      arrNuevoCliente.comision = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}
                    disabled={ !arrNuevoCliente.isVendedor }
                    />
                  </Col>
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalContactode">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Contacto de 
                  </Form.Label>
                  <Col sm={7}>
                    {/* Falta */}
                    <Form.Select
                    value={arrNuevoCliente.contacto_de}
                    onChange={
                      (ev) => {
                        arrNuevoCliente.contacto_de = ev.target.value;
                        dispatch( setStateGlobal({ arrNuevoCliente, }) )
                      }
                    }
                    >
                      <option value="">Selecciona un cliente...</option>
                      {
                        arrClientes.map((t,e) => (
                          <option value={t['_id']} key={`key-${e}`}>{t.nombre_completo}</option>
                        ))
                      }
                    </Form.Select>
                  </Col>
                </Form.Group>
              </Col> 

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalGiro">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Giro
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control name="giro" value={arrNuevoCliente.giro}  onChange={(ev) => {
                      arrNuevoCliente.giro = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}/>
                  </Col>
                </Form.Group>
              </Col>
              
              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalGrupo">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Grupo
                  </Form.Label>
                  <Col sm={7}>
                    {/* FALTA */}
                    <Form.Select value={arrNuevoCliente.grupo} onChange={(ev) => {
                      arrNuevoCliente.grupo = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}>
                      <option value="">Selecciona un grupo</option>
                      {
                        arrGrupos.map((t,e) => (
                          <option value={t['_id']}>{t.nombre}</option>
                        ))
                      }
                    </Form.Select>
                    <a href="" style={{color:'#f4244c'}} 
                    onClick={ 
                      (e) => {
                        e.preventDefault();
                        handleShowModalGrupo();
                      }
                    }
                    >Agregar grupo</a>
                    |
                    <a href="" onClick={
                      (e) => {
                        e.preventDefault();
                        handleShowModalEditarGrupo(true);
                      }
                    } style={{color:'#f4244c'}}>Modificar grupos</a>
                  </Col>
                </Form.Group>
              </Col>

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalPuesto">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Puesto
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control value={arrNuevoCliente.puesto} name="puesto" onChange={(ev) => {
                      arrNuevoCliente.puesto = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }} />
                  </Col>
                </Form.Group>
              </Col>      

              <Col xs={12} md={4}>
                <Form.Group as={Row} className="mb-3" controlId="formHorizontalNotas">
                  <Form.Label column sm={5} className="text-end ws-form-text-input">
                    Notas
                  </Form.Label>
                  <Col sm={7}>
                    <Form.Control value={arrNuevoCliente.notas  } 
                    onChange={(ev) => {
                      arrNuevoCliente.notas = ev.target.value
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}
                    as="textarea" name="notas" />
                  </Col>
                </Form.Group>
              </Col>

            </Row>
          </Form>
          
          <Table className="ws-table-directorio">
            <thead>
              <tr>
                <th colSpan={10}>
                  <a onClick={(e) => {
                    e.preventDefault();
                    arrNuevoCliente.newDireccion = !arrNuevoCliente.newDireccion
                    itemDireccion = { calle: '',colonia: '',ciudad: '',municipio: '',estado: '',telefono: '',tipo: '' };
                    dispatch( setStateGlobal({ arrNuevoCliente, }) )

                  }} href="" className="ws-button-tb"><i className="bi bi-plus"></i></a>
                  <span className='ws-main-content-top-item ws-main-content-text'>Agregar dirección</span>
                </th>
              </tr>
              <tr className="ws-table-directorio-options">
                <th></th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Calle</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Colonia</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Ciudad</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Municipio</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Estado</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Teléfono</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Tipo</span>
                </th>
                {/* <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Mapa</span>
                </th> */}
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Borrar</span>
                </th>
              </tr>
            </thead>
            <tbody>
              {
                arrNuevoCliente.newDireccion && (
                  <tr className="ws-table-directorio-options-body">
                    <td className='text-center'></td>

                    <td>
                      <Form.Control name="direccion_calle"  onChange={(ev) => {
                        itemDireccion.calle = ev.target.value
                      }}/>
                    </td>
                    <td>
                      <Form.Control name="direccion_colonia"  onChange={(ev) => {
                        itemDireccion.colonia = ev.target.value
                      }}/>
                    </td>
                    <td>
                      <Form.Control name="direccion_ciudad"  onChange={(ev) => {
                        itemDireccion.ciudad = ev.target.value
                      }}/>
                    </td>
                    <td>
                      <Form.Control name="direccion_municipio"  onChange={(ev) => {
                        itemDireccion.municipio = ev.target.value
                      }}/>
                    </td>
                    <td>
                      <Form.Control name="direccion_estado"  onChange={(ev) => {
                        itemDireccion.estado = ev.target.value
                      }}/>
                    </td>
                    <td>
                      <Form.Control name="direccion_telefono"  onChange={(ev) => {
                        itemDireccion.telefono = ev.target.value
                      }}/>
                    </td>
                    <td>
                      <Form.Control name="direccion_tipo"  onChange={(ev) => {
                        itemDireccion.tipo = ev.target.value
                      }}/>
                    </td>
                    <td className='text-center'>-</td>
                    <td className='text-center' onClick={() => {
                      arrNuevoCliente.arrDirecciones =  [...arrNuevoCliente.arrDirecciones, itemDireccion]
                      arrNuevoCliente.newDireccion = !arrNuevoCliente.newDireccion
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}>Agregar</td>
                  </tr>
                )
              }

              {
                arrNuevoCliente.arrDirecciones.map((t,e) => (
                  <tr className="ws-table-directorio-options-body">
                    <td className='text-center'><i className="bi bi-pencil-square ws-table-icon-option"></i></td>
                    <td>{t.calle}</td>
                    <td>{t.colonia}</td>
                    <td>{t.ciudad}</td>
                    <td>{t.municipio}</td>
                    <td>{t.estado}</td>
                    <td>{t.telefono}</td>
                    <td>{t.tipo}</td>
                    {/* <td className='text-center'><i className="bi bi-geo-alt ws-table-icon-option"></i></td> */}
                    <td className='text-center'><i className="bi bi-x-lg ws-table-icon-option red"></i></td>
                  </tr>
                ))
              }
            </tbody>
          </Table>
          <Table className="ws-table-directorio">
            <thead>
              <tr>
                <th colSpan={10}>
                  <a onClick={(e) => {
                    e.preventDefault();
                    arrNuevoCliente.newCorreo = !arrNuevoCliente.newCorreo
                    itemCorreo = { tipo_correo: 'EMPRESARIAL', correo: '', descripcion: '', };
                    dispatch( setStateGlobal({ arrNuevoCliente, }) )

                  }} href="" className="ws-button-tb"><i className="bi bi-plus"></i></a>
                  <span className='ws-main-content-top-item ws-main-content-text'>Agregar correo</span>
                </th>
              </tr>
              <tr className="ws-table-directorio-options">
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Tipo correo</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Correo</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Descripción</span>
                </th>
                {/* <th></th> */}
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                arrNuevoCliente.newCorreo && (
                  <tr className="ws-table-directorio-options-body">
                    <td>
                      <Form.Select onChange={(ev) => {
                        itemCorreo.tipo_correo = ev.target.value
                      }}>
                        <option value="" disabled={'disabled'}>SELECCIONA UN TIPO</option>
                        <option value="EMPRESARIAL">EMPRESARIAL</option>
                        <option value="PERSONAL">PERSONAL</option>
                      </Form.Select>
                    </td> 
                    <td>
                      <Form.Control name="correo"  onChange={(ev) => {
                        itemCorreo.correo = ev.target.value
                      }}/>
                    </td>
                    <td>
                      <Form.Control name="descripcion_correo"  onChange={(ev) => {
                        itemCorreo.descripcion = ev.target.value
                      }}/>
                    </td>
                    <td className='text-center'>-</td>
                    <td className='text-center' onClick={() => {
                      arrNuevoCliente.arrCorreos =  [...arrNuevoCliente.arrCorreos, itemCorreo]
                      arrNuevoCliente.newCorreo = !arrNuevoCliente.newCorreo
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                    }}>Agregar</td>
                  </tr>
                )
              }

              {
                arrNuevoCliente.arrCorreos.map((t,e) => (
                  <tr className="ws-table-directorio-options-body">
                    <td className='text-center'><i className="bi bi-pencil-square ws-table-icon-option"></i></td>
                    <td>{t.tipo_correo}</td>
                    <td>{t.correo}</td>
                    <td>{t.descripcion}</td>
                    {/* <td className='text-center'><i className="bi bi-geo-alt ws-table-icon-option"></i></td> */}
                    <td className='text-center'><i className="bi bi-x-lg ws-table-icon-option red"></i></td>
                  </tr>
                ))
              }
            </tbody>
          </Table>
          <Table className="ws-table-directorio">
            <thead>
              <tr>
                <th colSpan={10}>
                  <a onClick={() => {

                    

                  }} href="#" className="ws-button-tb"><i className="bi bi-plus"></i></a>
                  <span className='ws-main-content-top-item ws-main-content-text'>Agregar documentos</span>
                </th>
              </tr>
              <tr className="ws-table-directorio-options">
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Nombre del documento</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>URL</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Tipo</span>
                </th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
            </tbody>
          </Table>
          <Table className="ws-table-directorio">
            <thead>
              <tr>
                <th colSpan={10}>
                  <a onClick={(e) => {
                    e.preventDefault();
                    arrNuevoCliente.newAcceso = !arrNuevoCliente.newAcceso
                    dispatch( setStateGlobal({ arrNuevoCliente }) )
                  }} href="" className="ws-button-tb"><i className="bi bi-plus"></i></a>
                  <span className='ws-main-content-top-item ws-main-content-text'>Agregar acceso</span>
                </th>
              </tr>
              <tr className="ws-table-directorio-options">
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Dependencia</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Usuario</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Contraseña</span>
                </th>
                <th>
                  <span className='ws-main-content-top-item ws-main-content-text'>Observaciones</span>
                </th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                arrNuevoCliente.newAcceso && (
                  <tr className="ws-table-directorio-options-body">
                    <td>
                      <Form.Control type="text" name="dependencia" onChange={(ev) => {
                        itemAcceso.dependencia = ev.target.value
                      }} />
                    </td>
                    <td>
                      <Form.Control type="text" name="usuario" onChange={(ev) => {
                        itemAcceso.usuario = ev.target.value
                      }}/>
                    </td>
                    <td>
                      <Form.Control type="password" name="password" onChange={(ev) => {
                        itemAcceso.password = ev.target.value
                      }}/>
                    </td>
                    <td>
                      <Form.Control type="observaciones" name="observaciones" onChange={(ev) => {
                        itemAcceso.observaciones = ev.target.value
                      }}/>
                    </td>
                    <td className='text-center' onClick={() => {
                      
                      arrNuevoCliente.arrAccesos =  [...arrNuevoCliente.arrAccesos, itemAcceso]
                      arrNuevoCliente.newAcceso = !arrNuevoCliente.newAcceso
                      dispatch( setStateGlobal({ arrNuevoCliente, }) )
                      
                    }}>Agregar</td>
                  </tr>
                )
              }

              {
                arrNuevoCliente.arrAccesos.map((t,e) => (
                  <tr className="ws-table-directorio-options-body">
                    <td className='text-center'><i className="bi bi-pencil-square ws-table-icon-option"></i></td>
                    <td>{t.dependencia}</td>
                    <td>{t.usuario}</td>
                    <td>{t.password}</td>
                    <td>{t?.observaciones}</td>
                    <td className='text-center'><i className="bi bi-x-lg ws-table-icon-option red"></i></td>
                  </tr>
                ))
              }
            </tbody>
          </Table>

          <Modal show={modalGrupo} onHide={handleCloseModalGrupo}>
            <Modal.Header closeButton className="title">
              <Modal.Title>Nuevo grupo</Modal.Title>
            </Modal.Header>
            <Modal.Body className="ws-modal-body">
              <Form onSubmit={handleSubmitFormGrupo} className="ws-box-container">
                <Form.Group className="mb-2">
                  <Form.Label>Nombre</Form.Label>
                  <Form.Control type="text" name="nombre_grupo" placeholder="Agrega el nombre del grupo" required />
                </Form.Group>
                <Form.Group>
                  <Button type="submit" className="ws-btn-blue-2">Agregar</Button>
                </Form.Group>
              </Form>
            </Modal.Body>
          </Modal>

          <Modal
          show={modalEditarGrupo}
          onHide={handleCloseModalEditarGrupo}
          >
            <Modal.Header closeButton className="title">
              <Modal.Title>Editar Grupos</Modal.Title>
            </Modal.Header>
            <Modal.Body className="ws-modal-body">  
              <div className="ws-box-container">
                <Table> 
                  <thead>
                    <tr>
                      <th width="70%">Nombre</th>
                      <th width="30">Opciones</th>
                    </tr>
                  </thead>
                  <tbody>
                    {
                      arrGrupos.map((t,e) => (
                        <tr>  
                          <td>
                            {
                            indexEditarGrupo === e ?
                              <Form.Control ref={refInputEditar} type="text" defaultValue={t.nombre} />
                            :
                              t.nombre
                            }
                          </td>
                          <td>
                            {
                              indexEditarGrupo === e ?
                              <Button 
                              disabled={btnLoadingEditar}
                              className="ws-btn-blue-2"
                              onClick={
                                (ev) => {
                                  // console.log('item',t);
                                  saveEditarGrupo(t);
                                }
                              }
                              >
                                { 
                                btnLoadingEditar 
                                ?
                                  <Spinner animation="border" size="sm" /> 
                                : 
                                  <i class="bi bi-check-lg"></i> 
                                } Guardar 
                              </Button>
                              :
                              <Button 
                              disabled={btnLoadingEditar}
                              className="ws-btn-blue-2"
                              onClick={
                                () => {
                                  setIndexEditarGrupo(e);
                                }
                              }
                              ><i class="bi bi-pencil-fill"></i> Editar</Button>
                            }
                          </td>
                        </tr>
                      ))
                    }
                  </tbody>
                </Table>
              </div>
            </Modal.Body>
          </Modal>
          {/* <Button className="ws-btn-blue-2"
            onClick={ () => {
              window.location.href = "/"
            }}
            ><i className="bi bi-arrow-left"></i>&nbsp;Atrás</Button>&nbsp; */}
          <hr />
          <Button
            onClick={
              () => {
                // window.location.href = 'nuevaCotizacion'
                arrNuevoCliente.nombre_completo = `${arrNuevoCliente.nombre} ${arrNuevoCliente.paterno} ${arrNuevoCliente.materno}`
                dispatch( setStateGlobal({ arrNuevoCliente, }) )

                const data = {
                  ...arrNuevoCliente,
                }

                setBtnSaveIsLoading(true);

                fetch('https://mercedes.wsoft.com.mx/interbrokers/REST/Controller.php?opt=saveCliente',{
                  method: 'POST',
                  model: 'cors',
                  body: JSON.stringify(data)
                })
                .then( response => response.json())
                .then( res => {
                  setBtnSaveIsLoading(false);
                  if(!arrNuevoCliente.update) {
                    // alert('Nuevo cliente registrado con éxito')
                    dispatch(showAlert({
                      show : true, 
                      message : 'Nuevo cliente registrado con éxito.',
                      type: 'success',
                      duration: 3000,
                    }))
                    if(_GET('ref') === 'nuevacotizacion'){
                      setTimeout( () => {
                        window.location.href = `nuevaCotizacion?id=${res.insertedId}`
                      },2000)
                    }else{
                      setTimeout( () =>  {
                        window.location.href = '/'
                      },2000)
                    }
                    // socket.emit("toCajero", { client: 'hgapp', substrace: 'updateCost', }) 
                    // setTimeout(() => {
                    // }, 3000)
                  }
                  else
                    dispatch(showAlert({
                      show : true, 
                      message : 'Cliente actualizado con éxito.',
                      type: 'success',
                      duration: 3000,
                    }))
                } )

              }
            }
            disabled={btnSaveIsLoading}
            className={'ws-btn-blue-2'}>{
            !arrNuevoCliente.update 
            ? 
              btnSaveIsLoading 
              ?
              <>Registrando... <Spinner animation="border" size="sm" /></>
              :
              'Registrar y continuar' 
            : 
              btnSaveIsLoading
              ?
              <>Actualizando... <Spinner animation="border" size="sm" /></>
              :
              'Actualizar contacto'
            }</Button>
        </div>
      </div>
    </div>
  )
}




